<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <AllTabs></AllTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AllTabs from "@/components/PagesComponents/ManageAccounts/AllTabs";
export default {
  components: {
    AllTabs,
  },
};
</script>
